import { environment } from '../../environments/environment';

export class AppSettings {

  public static get build() { return 51; }
  public static get version() { return '1.6.5'; }
  public static get buildDate() { return 'Sep 24, 2026'; }

  public static get apiURL() { return environment.apiURL; }
  public static get hubURL() { return environment.hubURL; }
  public static get clientUrl() { return environment.clientUrl; }
  public static get bidBeaconUrl() { return environment.bidBeaconUrl; }
  public static get cbsApiUrl() { return environment.cbsApiUrl; }
  public static get isProduction() { return environment.production; }
}
